import { all, call, putResolve, select, take, takeLatest } from "redux-saga/effects";

import { getIsAuroraV2Design } from "../../lib/selectors";
import { fetchAuroraV2Abilities, syncAuroraV2Design } from "./aurora-V2.actions";
import auroraV2Slice from "./aurora-V2.slice";

function* sync() {
  const syncCall = yield call(syncAuroraV2Design);
  yield putResolve(syncCall);
}

export function* auroraV2Saga() {
  yield all([take("proposal/fetch/fulfilled"), take("template/fetch/fulfilled")]);
  const isAuroraV2Design = yield select(getIsAuroraV2Design);
  if (isAuroraV2Design) {
    const abilities = yield call(fetchAuroraV2Abilities);
    yield putResolve(abilities);
    yield takeLatest(auroraV2Slice.actions.syncAuroraV2, sync);
  }
}
